;; AI-GENERATED — Disposable UI Components
;; Styled components and view helpers for the Calendar Data Explorer.
;; This file is for AI reference only. Not production UI. May be
;; regenerated or discarded at any time.
(ns hai.library.connections.disposable-ui
  (:require
   [lambdaisland.ornament :as o]))

;; ---------------------------------------------------------------------------
;; Layout
;; ---------------------------------------------------------------------------

;; Top-level flex container for the explorer (sidebar + main)
(o/defstyled explorer-layout :div
  :flex :gap-4 :h-full
  {:min-height "500px"})

;; Base panel with border, background, padding, and scroll
(o/defstyled panel :div
  :flex :flex-col :gap-2 :overflow-y-auto :rounded-lg :p-4
  {:border "1px solid var(--gray-6)"
   :background "var(--color-surface)"})

;; Fixed-width sidebar panel
(o/defstyled left-panel panel
  {:width "320px"
   :flex-shrink "0"})

;; Flexible main content panel
(o/defstyled right-panel panel
  {:flex "1"})

;; ---------------------------------------------------------------------------
;; Calendar List
;; ---------------------------------------------------------------------------

;; Clickable calendar row with hover/selected states
(o/defstyled calendar-item :div
  :p-3 :rounded-md :cursor-pointer
  {:border "1px solid var(--gray-4)"
   :transition "all 0.15s ease"}
  [:&:hover {:background "var(--gray-3)"}]
  [:&.selected {:background "var(--accent-3)"
                :border-color "var(--accent-7)"}])

;; Calendar name with color swatch and primary badge
(o/defstyled calendar-title :div
  :font-medium :text-sm :flex :items-center :gap-1
  {:min-width 0})

;; Timezone and role metadata line
(o/defstyled calendar-meta :div
  :text-xs {:color "var(--gray-11)"})

;; Small accent pill for the primary calendar
(o/defstyled primary-badge :span
  :text-xs :px-1 :rounded :whitespace-nowrap
  {:background "var(--accent-3)"
   :color "var(--accent-11)"})

;; ---------------------------------------------------------------------------
;; Event Table View
;; ---------------------------------------------------------------------------

;; Container for a single event in table mode
(o/defstyled event-card :div
  :p-3 :rounded-md
  {:border "1px solid var(--gray-4)"})

;; Event summary text in table mode
(o/defstyled event-title :div
  :font-medium :text-sm)

;; Secondary event metadata line
(o/defstyled event-meta :div
  :text-xs {:color "var(--gray-11)"})

;; Extra detail line below event meta
(o/defstyled event-detail :div
  :text-xs :mt-1 {:color "var(--gray-11)"})

;; ---------------------------------------------------------------------------
;; Attribute Table (key-value display)
;; ---------------------------------------------------------------------------

;; Single key-value row
(o/defstyled attr-row :div
  :flex :gap-2 :text-xs :py-1
  {:border-bottom "1px solid var(--gray-3)"})

;; Attribute key label
(o/defstyled attr-key :span
  :font-mono
  {:color "var(--accent-11)"
   :min-width "180px"
   :flex-shrink "0"})

;; Attribute value text with badge
(o/defstyled attr-val :span
  :flex :items-center :gap-1
  {:color "var(--gray-12)"
   :word-break "break-all"})

;; Tiny monospace pill showing value type (b/n/s/c/?) with per-type colors
(o/defstyled type-badge :span
  :font-mono :rounded :px-1
  {:font-size "9px"
   :line-height "14px"
   :min-width "14px"
   :text-align "center"
   :flex-shrink "0"
   ;; default (string)
   :color "var(--gray-9)"
   :background "var(--gray-3)"}
  [:&.type-b {:color "var(--amber-11)" :background "var(--amber-3)"}]
  [:&.type-n {:color "var(--blue-11)" :background "var(--blue-3)"}]
  [:&.type-c {:color "var(--violet-11)" :background "var(--violet-3)"}]
  [:&.type-nil {:color "var(--red-11)" :background "var(--red-3)"}])

;; ---------------------------------------------------------------------------
;; Section / Status
;; ---------------------------------------------------------------------------

;; Section heading text
(o/defstyled section-heading :h3
  :text-sm :font-semibold :mb-2
  {:color "var(--gray-12)"})

;; Loading spinner placeholder text
(o/defstyled loading-text :div
  :text-sm :p-4 {:color "var(--gray-11)"})

;; Centered empty state message
(o/defstyled empty-state :div
  :text-sm :p-4 {:color "var(--gray-11)"
                 :text-align "center"})

;; Error message with red background
(o/defstyled error-text :div
  :text-sm :p-4 :rounded-md
  {:color "var(--red-11)"
   :background "var(--red-3)"
   :border "1px solid var(--red-6)"
   :word-break "break-all"})

;; ---------------------------------------------------------------------------
;; Filter Bar
;; ---------------------------------------------------------------------------

;; Flex row wrapping filter inputs and apply button
(o/defstyled filter-bar :div
  :flex :items-center :gap-3 :mb-3 :flex-wrap :text-xs
  {:padding "8px 12px"
   :border "1px solid var(--gray-5)"
   :border-radius "6px"
   :background "var(--gray-2)"})

;; Small numeric input for filter values
(o/defstyled filter-input :input
  :text-xs :rounded :px-2 :py-1
  {:width "60px"
   :border "1px solid var(--gray-6)"
   :background "var(--color-surface)"})

;; Accent apply button
(o/defstyled apply-btn :button
  :text-xs :font-medium :rounded :px-3 :py-1 :cursor-pointer
  {:background "var(--accent-9)"
   :color "white"
   :border "none"}
  [:&:hover {:background "var(--accent-10)"}])

;; Event count shown at right of filter bar
(o/defstyled event-count-text :span
  :text-xs :ml-auto
  {:color "var(--gray-11)"})

;; ---------------------------------------------------------------------------
;; Card View Toggle
;; ---------------------------------------------------------------------------

;; Flex row container for the switch + label
(o/defstyled view-toggle :div
  :flex :items-center :gap-2 :ml-3)

;; Label text next to the toggle switch
(o/defstyled toggle-label :span
  :text-xs :font-medium
  {:color "var(--gray-11)"})

;; ---------------------------------------------------------------------------
;; Friendly Card View
;; ---------------------------------------------------------------------------

;; Card container with hover border effect
(o/defstyled friendly-card :div
  :p-4 :rounded-lg
  {:border "1px solid var(--gray-4)"
   :transition "border-color 0.15s ease"}
  [:&:hover {:border-color "var(--accent-7)"}])

;; Event title in card view
(o/defstyled friendly-card-title :div
  :font-medium :text-sm :mb-2
  {:color "var(--gray-12)"})

;; Label + value row in card view
(o/defstyled friendly-field :div
  :flex :gap-2 :text-xs :py-0.5)

;; Field label ("Time", "Location")
(o/defstyled friendly-label :span
  :font-medium
  {:color "var(--gray-9)"
   :min-width "70px"
   :flex-shrink "0"})

;; Field value text
(o/defstyled friendly-value :span
  {:color "var(--gray-12)"})

;; Accent-colored link to open event in GCal
(o/defstyled event-link :a
  :text-xs :no-underline
  {:color "var(--accent-11)"}
  [:&:hover {:text-decoration "underline"}])

;; Small pill for event status
(o/defstyled status-badge :span
  :text-xs :px-1.5 :py-0.5 :rounded-full
  {:background "var(--gray-3)"
   :color "var(--gray-11)"})

;; ---------------------------------------------------------------------------
;; Generic List Items (for Linear teams, issues, etc.)
;; ---------------------------------------------------------------------------

;; Clickable list row with hover/selected states (generic version of calendar-item)
(o/defstyled list-item :div
  :p-3 :rounded-md :cursor-pointer
  {:border "1px solid var(--gray-4)"
   :transition "all 0.15s ease"}
  [:&:hover {:background "var(--gray-3)"}]
  [:&.selected {:background "var(--accent-3)"
                :border-color "var(--accent-7)"}])

;; List item name/title
(o/defstyled list-item-title :div
  :font-medium :text-sm :flex :items-center :gap-1
  {:min-width 0})

;; List item metadata line
(o/defstyled list-item-meta :div
  :text-xs {:color "var(--gray-11)"})

;; ---------------------------------------------------------------------------
;; Badges
;; ---------------------------------------------------------------------------

;; Color-coded priority badge (P0=urgent … P4=none)
(o/defstyled priority-badge :span
  :text-xs :px-1.5 :py-0.5 :rounded :font-medium :whitespace-nowrap
  {:background "var(--gray-3)"
   :color "var(--gray-11)"})

;; Workflow state pill
(o/defstyled state-badge :span
  :text-xs :px-1.5 :py-0.5 :rounded-full :whitespace-nowrap
  {:background "var(--gray-3)"
   :color "var(--gray-11)"})

;; ---------------------------------------------------------------------------
;; Inline Form
;; ---------------------------------------------------------------------------

;; Horizontal form row for create forms
(o/defstyled inline-form :div
  :flex :items-end :gap-3 :p-3 :rounded-lg :flex-wrap
  {:border "1px solid var(--gray-5)"
   :background "var(--gray-2)"})

;; Basic text input
(o/defstyled text-input :input
  :text-sm :rounded :px-2 :py-1
  {:border "1px solid var(--gray-6)"
   :background "var(--color-surface)"
   :flex "1"
   :min-width "200px"})

;; Basic select dropdown
(o/defstyled select-input :select
  :text-sm :rounded :px-2 :py-1
  {:border "1px solid var(--gray-6)"
   :background "var(--color-surface)"})

;; ---------------------------------------------------------------------------
;; View Helpers
;; ---------------------------------------------------------------------------

(defn value-type-indicator
  "Returns a single-char type indicator for an attribute value."
  [v]
  (cond
    (nil? v)                      "?"
    (boolean? v)                  "b"
    (number? v)                   "n"
    (or (map? v) (sequential? v)) "c"
    :else                         "s"))

(defn type-badge-class
  "Returns the CSS class for a type indicator badge."
  [v]
  (cond
    (nil? v)                      "type-nil"
    (boolean? v)                  "type-b"
    (number? v)                   "type-n"
    (or (map? v) (sequential? v)) "type-c"
    :else                         nil))

(defn format-attr-value
  "Formats an attribute value for display in the attr table."
  [v]
  (cond
    (nil? v) "—"
    (boolean? v) (str v)
    (map? v) (pr-str v)
    (sequential? v) (pr-str v)
    :else (str v)))

(defn attr-table
  "Renders a sorted key-value table with type badges."
  [m]
  [:div
   (for [[k v] (sort-by (comp str key) m)]
     ^{:key (str k)}
     [attr-row
      [attr-key (str k)]
      [attr-val
       [type-badge {:class (type-badge-class v)} (value-type-indicator v)]
       (format-attr-value v)]])])

(defn format-event-time
  "Formats a GCal event datetime map to a readable string."
  [time-map]
  (when time-map
    (or (:gcal.event-datetime/date-time time-map)
        (str (:gcal.event-datetime/date time-map) " (all day)"))))
